import { IQCAdminAppContext } from 'app/components/containers/IQCAdminApp';
import { useContext } from 'react';

export const useScrollToTop = () => {
  const { scrollToTop } = useContext(IQCAdminAppContext);

  return scrollToTop;
};
